// import React, { useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Login from './Components/Login/Login';
// import MainLayout from './layouts/MainLayout';
// import Billing from './pages/Billing/Billing';
// import Profile from './pages/Profile';
// import UserInvite from './pages/UserInvite';
// import AddInvite from './pages/AddInvite';
// import NewUsers from './pages/NewUsers';
// import AddNewUsers from './pages/AddNewUsers';
// import RoleTable from './pages/RoleTable';
// import AddRoles from './pages/AddRoles';
// import PermissionsTable from './pages/PermissionsTable';
// import AddPermission from './pages/AddPermission';
// import { ToastContainer } from 'react-toastify';
// import UserType from './pages/Usertype/UserType';
// import PrivateRoute from './Components/Common/PrivateRoute';
// import ResetPassword from './pages/ResetPassword/ResetPassword';
// import UserProfile from './pages/UserProfile/UserProfile';
// import AddUserType from './pages/Usertype/AddUserType';
// import OrderTable from './pages/Order/OrderTable';
// import CreateOrders from './pages/Order/CreateOrders';
// import AddItem from './pages/Order/AddItem';
// import TermsAndConditions from './pages/Terms/TermsAndConditions';
// import MyOrders from './pages/Order/MyOrders';
// import UpdateMyOrder from './pages/Order/UpdateMyOrder';
// import InvoiceTable from './pages/Invoice/InvoiceTable';
// import AddInvoice from './pages/Invoice/AddInvoice';
// import MyInvoice from './pages/Invoice/MyInvoice';
// import UpdateMyInvoice from './pages/Invoice/UpdateMyInvoice';
// import InventoryTable from './pages/InventoryManagement/InventoryTable';
// import AddNewItems from './pages/InventoryManagement/AddNewItems';
// import PriceCategory from './pages/InventoryManagement/PriceCategory';
// import AddBilling from './pages/Billing/AddBilling';
// import Dashboard from './pages/Dashboard/Dashboard';
// import ApproveOrders from './pages/Order/ApproveOrders';
// import Reports from './pages/Reports/Reports';
// import Notifications from './pages/Notification/Notifications';
// import Settings from './pages/Settings/Settings';
// import Calculate from './pages/Billing/Calculate';
// import ViewMyBilling from './pages/Billing/ViewMyBilling';
// import ViewFarmerMyBilling from './pages/Billing/ViewFarmerMyBilling';
// import Ledger from './pages/Ledger/Ledger';
// import ViewLadger from './pages/Ledger/ViewLadger';
// import ViewLedgerId from './pages/Ledger/ViewLedgerId';
// import ViewReports from './pages/Reports/ViewReports';
// import PayableViewLadger from './pages/Ledger/PayableViewLadger';
// import PayableViewLadgerId from './pages/Ledger/PayableViewLadgerId';
// import ExpenseTable from './pages/Expense/ExpenseTable';
// import ViewInvoice from './pages/Invoice/ViewInvoice';
// import WebHeader from './Components/Header/WebHeader';
// import Features from './Components/WebHomePages/Features';
// import PublicLayout from './Components/WebHomePages/PublicLayout';
// import Priceing from './Components/WebHomePages/Priceing';
// import WebContact from './Components/WebHomePages/WebContact';
// import AppDownload from './Components/WebHomePages/AppDownload';
// import AcceptInvite from './Components/AcceptInvite/AcceptInvite';

// const App = () => {


//     useEffect(() => {
//     if (!window.googleTranslateElementInit) {
//       window.googleTranslateElementInit = () => {
//         new window.google.translate.TranslateElement(
//           { pageLanguage: "en" },
//           "google_translate_element"
//         );
//       };
//     }

//     if (!document.getElementById("google-translate-script")) {
//       const script = document.createElement("script");
//       script.id = "google-translate-script";
//       script.src =
//         "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//       document.body.appendChild(script);
//     }
//   }, []);


//   return (
//     <>
//     <div
//         id="google_translate_element"
//         style={{ visibility: "hidden", height: 0, width: 0 }}
//       ></div>
//       <Router>
//         <Routes>

//           <Route element={<PublicLayout />}>
//             {/* <Route path="/features" element={<Features />} />
//             <Route path="/pricing" element={<Priceing />} />
//             <Route path="/contact" element={<WebContact />} />
//             <Route path="/download" element={<AppDownload />} /> */}
//             {/* <Route path="/header" element={ */}
//             <Route path="/" element={
//               <div>
//                 <section id="features">
//                   <Features />
//                 </section>

//                 <section id="Freemium">
//                   <Priceing />
//                 </section>

//                 <section id="download">
//                   <AppDownload />
//                 </section>

//                 <section id="contact">
//                   <WebContact />
//                 </section>
//               </div>
//             }
//             />
//           </Route>



//           <Route path="/login" element={<Login />} />
//           <Route path="/acceptinvite" element={<AcceptInvite />} />
//           <Route path="/Resetpassword" element={<ResetPassword />} />
//           <Route path="/Profiles" element={<UserProfile />} />
//           <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
//           {/* Protected Routes */}
//           <Route element={<PrivateRoute />}>
//             <Route path="/dashboard" element={<MainLayout />}>
//               <Route index element={<Dashboard />} />
//               <Route path="billing" element={<Billing />} />
//               <Route path="Profile" element={<Profile />} />
//               <Route path="Invite" element={<UserInvite />} />
//               <Route path="AddInvite" element={<AddInvite />} />
//               <Route path="Users" element={<NewUsers />} />
//               <Route path="User" element={<AddNewUsers />} />
//               <Route path="Role" element={<RoleTable />} />
//               <Route path="Roles" element={<AddRoles />} />
//               <Route path="Permissions" element={<PermissionsTable />} />
//               <Route path="Permission" element={<AddPermission />} />
//               <Route path="UserType" element={<UserType />} />
//               <Route path="UserTypes" element={<AddUserType />} />
//               <Route path="Ordertable" element={<OrderTable />} />
//               <Route path="CreateOrders" element={<CreateOrders />} />
//               <Route path="AddItem" element={<AddItem />} />
//               <Route path="Myorders" element={<MyOrders />} />
//               <Route path="UpdateMyOrder" element={<UpdateMyOrder />} />
//               <Route path="Invoicetable" element={<InvoiceTable />} />
//               <Route path="CreateInvoice" element={<AddInvoice />} />
//               <Route path="Myinvoice" element={<MyInvoice />} />
//               <Route path="UpdateMyInvoice" element={<UpdateMyInvoice />} />
//               <Route path="InventoryTable" element={<InventoryTable />} />
//               <Route path="AddNewItems" element={<AddNewItems />} />
//               <Route path="PriceCategory" element={<PriceCategory />} />
//               <Route path="AddBilling" element={<AddBilling />} />
//               <Route path="ApproveOrders" element={<ApproveOrders />} />
//               <Route path="Reports" element={<Reports />} />
//               <Route path="Notifications" element={<Notifications />} />
//               <Route path="Settings" element={<Settings />} />
//               <Route path="Calculate" element={<Calculate />} />
//               <Route path="MyBilling" element={<ViewMyBilling />} />
//               <Route path="ViewBilling" element={<ViewFarmerMyBilling />} />
//               <Route path="Ledger" element={<Ledger />} />
//               <Route path="ViewLadger" element={<ViewLadger />} />
//               <Route path="ViewItems" element={<ViewLedgerId />} />
//               <Route path="Viewreports" element={<ViewReports />} />
//               <Route path="PayableViewLadger" element={<PayableViewLadger />} />
//               <Route path="PayableViewLadgerId" element={<PayableViewLadgerId />} />
//               <Route path="ExpenseTable" element={<ExpenseTable />} />
//               <Route path="ViewMyInvoice" element={<ViewInvoice />} />

//             </Route>
//           </Route>
//         </Routes>
//       </Router>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default App;

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Login/Login';
import MainLayout from './layouts/MainLayout';
import Billing from './pages/Billing/Billing';
import Profile from './pages/Profile';
import UserInvite from './pages/UserInvite';
import AddInvite from './pages/AddInvite';
import NewUsers from './pages/NewUsers';
import AddNewUsers from './pages/AddNewUsers';
import RoleTable from './pages/RoleTable';
import AddRoles from './pages/AddRoles';
import PermissionsTable from './pages/PermissionsTable';
import AddPermission from './pages/AddPermission';
import { ToastContainer } from 'react-toastify';
import UserType from './pages/Usertype/UserType';
import PrivateRoute from './Components/Common/PrivateRoute';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import UserProfile from './pages/UserProfile/UserProfile';
import AddUserType from './pages/Usertype/AddUserType';
import OrderTable from './pages/Order/OrderTable';
import CreateOrders from './pages/Order/CreateOrders';
import AddItem from './pages/Order/AddItem';
import TermsAndConditions from './pages/Terms/TermsAndConditions';
import MyOrders from './pages/Order/MyOrders';
import UpdateMyOrder from './pages/Order/UpdateMyOrder';
import InvoiceTable from './pages/Invoice/InvoiceTable';
import AddInvoice from './pages/Invoice/AddInvoice';
import MyInvoice from './pages/Invoice/MyInvoice';
import UpdateMyInvoice from './pages/Invoice/UpdateMyInvoice';
import InventoryTable from './pages/InventoryManagement/InventoryTable';
import AddNewItems from './pages/InventoryManagement/AddNewItems';
import PriceCategory from './pages/InventoryManagement/PriceCategory';
import AddBilling from './pages/Billing/AddBilling';
import Dashboard from './pages/Dashboard/Dashboard';
import ApproveOrders from './pages/Order/ApproveOrders';
import Reports from './pages/Reports/Reports';
import Notifications from './pages/Notification/Notifications';
import Settings from './pages/Settings/Settings';
import Calculate from './pages/Billing/Calculate';
import ViewMyBilling from './pages/Billing/ViewMyBilling';
import ViewFarmerMyBilling from './pages/Billing/ViewFarmerMyBilling';
import Ledger from './pages/Ledger/Ledger';
import ViewLadger from './pages/Ledger/ViewLadger';
import ViewLedgerId from './pages/Ledger/ViewLedgerId';
import ViewReports from './pages/Reports/ViewReports';
import PayableViewLadger from './pages/Ledger/PayableViewLadger';
import PayableViewLadgerId from './pages/Ledger/PayableViewLadgerId';
import ExpenseTable from './pages/Expense/ExpenseTable';
import ViewInvoice from './pages/Invoice/ViewInvoice';
import WebHeader from './Components/Header/WebHeader';
import Features from './Components/WebHomePages/Features';
import PublicLayout from './Components/WebHomePages/PublicLayout';
import Priceing from './Components/WebHomePages/Priceing';
import WebContact from './Components/WebHomePages/WebContact';
import AppDownload from './Components/WebHomePages/AppDownload';
import AcceptInvite from './Components/AcceptInvite/AcceptInvite';
import ItemCategoriesTable from './pages/ItemCategories/ItemCategoriesTable';
import HelpCenterNormalUser from './pages/HelpCenter/HelpCenterNormalUser';
import HelpCenterAdmin from './pages/HelpCenter/HelpCenterAdmin';
import HelpCenterUserView from './pages/HelpCenter/HelpCenterUserView';
import HelpCenterAdminView from './pages/HelpCenter/HelpCenterAdminView';
import Plans from './pages/Plans/Plans';
import SubscriptionAdmin from './pages/Plans/SubscriptionAdmin';
import SubscriptionUser from './pages/Plans/SubscriptionUser';
import TransportHandlers from './pages/TransportHandlers/TransportHandlers';
import TransportHandlersBillingView from './pages/TransportHandlers/TransportHandlersBillingView';
import AssetSingleView from './pages/Billing/AssetCount/AssetSingleView';
import ThermalPrintSettings from './pages/Settings/ThermalPrintSettings';
import BannerSettings from './pages/Settings/BannerSettings';
import RS232Settings from './pages/Settings/RS232Settings';
import OrganizationSettings from './pages/Settings/OrganizationSettings';
import PaymentSettings from './pages/Settings/PaymentSettings';
import DownloadHistory from './pages/Settings/DownloadHistory';
import UserQuery from './pages/Settings/UserQuery';

const App = () => {
  useEffect(() => {
    // Set language class on app load
    const savedLang = localStorage.getItem("appLanguage") || "English";
    const languageMap = {
      English: "en",
      Tamil: "ta",
      Telugu: "te",
      Malayalam: "ml",
      Kannada: "kn",
      Hindi: "hi",
    };

    document.body.className = document.body.className.replace(/lang-\w+/g, '');
    if (savedLang !== 'English') {
      document.body.classList.add(`lang-${languageMap[savedLang]}`);
    }

    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
      if (this.contains(child)) {
        return originalRemoveChild.call(this, child);
      }
      return child;
    };

    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", autoDisplay: false },
          "google_translate_element"
        );
      };
    }

    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(script);
    }

    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      window.deferredPrompt = e;
      console.log('beforeinstallprompt event fired');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      Node.prototype.removeChild = originalRemoveChild;
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);


  return (
    <>
      <div
        id="google_translate_element"
        style={{ visibility: "hidden", height: 0, width: 0 }}
      ></div>
      <Router>
        <Routes>

          <Route element={<PublicLayout />}>
            {/* <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Priceing />} />
            <Route path="/contact" element={<WebContact />} />
            <Route path="/download" element={<AppDownload />} /> */}
            {/* <Route path="/header" element={ */}
            <Route path="/" element={
              <div>
                <section id="features">
                  <Features />
                </section>


                <section id="Freemium">
                  <Priceing />
                </section>
                <section id="download">
                  <AppDownload />
                </section>

                <section id="contact">
                  <WebContact />
                </section>
              </div>
            }
            />
          </Route>



          <Route path="/login" element={<Login />} />
          <Route path="/acceptinvite" element={<AcceptInvite />} />
          <Route path="/Resetpassword" element={<ResetPassword />} />
          <Route path="/Profiles" element={<UserProfile />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<MainLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="billing" element={<Billing />} />
              <Route path="Profile" element={<Profile />} />
              <Route path="Invite" element={<UserInvite />} />
              <Route path="AddInvite" element={<AddInvite />} />
              <Route path="Users" element={<NewUsers />} />
              <Route path="User" element={<AddNewUsers />} />
              <Route path="Role" element={<RoleTable />} />
              <Route path="Roles" element={<AddRoles />} />
              <Route path="Permissions" element={<PermissionsTable />} />
              <Route path="Permission" element={<AddPermission />} />
              <Route path="UserType" element={<UserType />} />
              <Route path="UserTypes" element={<AddUserType />} />
              <Route path="Ordertable" element={<OrderTable />} />
              <Route path="CreateOrders" element={<CreateOrders />} />
              <Route path="AddItem" element={<AddItem />} />
              <Route path="Myorders" element={<MyOrders />} />
              <Route path="UpdateMyOrder" element={<UpdateMyOrder />} />
              <Route path="Invoicetable" element={<InvoiceTable />} />
              <Route path="CreateInvoice" element={<AddInvoice />} />
              <Route path="Myinvoice" element={<MyInvoice />} />
              <Route path="UpdateMyInvoice" element={<UpdateMyInvoice />} />
              <Route path="InventoryTable" element={<InventoryTable />} />
              <Route path="AddNewItems" element={<AddNewItems />} />
              <Route path="PriceCategory" element={<PriceCategory />} />
              <Route path="AddBilling" element={<AddBilling />} />
              <Route path="ApproveOrders" element={<ApproveOrders />} />
              <Route path="Reports" element={<Reports />} />
              <Route path="Notifications" element={<Notifications />} />
              <Route path="Settings" element={<Settings />} />
              <Route path="ThermalPrintSettings" element={<ThermalPrintSettings />} />
              <Route path="OrganizationSettings" element={<OrganizationSettings />} />
              <Route path="PaymentSettings" element={<PaymentSettings />} />
              <Route path="BannerSettings" element={<BannerSettings />} />
              <Route path="RS232Settings" element={<RS232Settings />} />
              <Route path="DownloadHistory" element={<DownloadHistory />} />
              <Route path="UserQuery" element={<UserQuery />} />
              <Route path="Calculate" element={<Calculate />} />
              <Route path="MyBilling" element={<ViewMyBilling />} />
              <Route path="ViewBilling" element={<ViewFarmerMyBilling />} />
              <Route path="Ledger" element={<Ledger />} />
              <Route path="ViewLadger" element={<ViewLadger />} />
              <Route path="ViewItems" element={<ViewLedgerId />} />
              <Route path="Viewreports" element={<ViewReports />} />
              <Route path="PayableViewLadger" element={<PayableViewLadger />} />
              <Route path="PayableViewLadgerId" element={<PayableViewLadgerId />} />
              <Route path="ExpenseTable" element={<ExpenseTable />} />
              <Route path="ViewMyInvoice" element={<ViewInvoice />} />
              <Route path="ItemCategories" element={<ItemCategoriesTable />} />
              <Route path="HelpCenter" element={<HelpCenterNormalUser />} />
              <Route path="HelpCenterAdmin" element={<HelpCenterAdmin />} />
              <Route path="HelpCenterUserView" element={<HelpCenterUserView />} />
              <Route path="HelpCenterAdminView" element={<HelpCenterAdminView />} />
              <Route path="Plans" element={<Plans />} />
              <Route path="SubscriptionAdmin" element={<SubscriptionAdmin />} />
              <Route path="SubscriptionUser" element={<SubscriptionUser />} />
              <Route path="TransportHandlers" element={<TransportHandlers />} />
              <Route path="TransportHandlersBillingView" element={<TransportHandlersBillingView />} />
              <Route path="AssetView" element={<AssetSingleView />} />


            </Route>
          </Route>
        </Routes>
      </Router>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default App;

